
export function formatNumber(num, decimals = 2) {
  if (num >= 1_000_000_000) {
    return (num / 1_000_000_000).toFixed(decimals) + 'B'; // Billions
  } else if (num >= 1_000_000) {
    return (num / 1_000_000).toFixed(decimals) + 'M'; // Millions
  } else if (num >= 1_000) {
    return (num / 1_000).toFixed(decimals) + 'K'; // Thousands
  }
  return num.toString();
}

export function formatNumber2Digits(value, locale, digits = 2) {
  if (value === undefined || value === null) return '—';
  return new Intl.NumberFormat(locale, {
    minimumFractionDigits: 0,
    maximumFractionDigits: digits
  }).format(value);
}

export function formatCurrency(value, locale, currency) {
  if (value === undefined || value === null) return '—';
  try {
    return new Intl.NumberFormat(locale, {
      style: 'currency',
      currency,
      maximumFractionDigits: 0
    }).format(value);
  } catch {
    return Number(value).toLocaleString();
  }
}

export function roundTo2IfNumber(num) {
  if (typeof num !== 'number' || isNaN(num)) {
    // Se não for número (ou for NaN), apenas retorna o valor original
    return num;
  }
  return Math.round(num * 100) / 100;
}


